<template>
  <div class="ws-state-locales">
    <!-- <div class="locales-select-section">
      <v-icon color="textPrimary">mdi-web</v-icon>
      <div class="locales-select-section__title textPrimary--text">你正在編輯的語言是</div>
      <WsStateSelect
        minWidth="130px"
        v-model="selectingLocale"
        :items="_localeItems"
        round
        evevate
      ></WsStateSelect>
    </div> -->
    <!-- value {{value}} fielsd{{fields}} -->
    <v-row v-if="value">

      <v-col
        v-for="(field, fieldKey) in fields"
        cols="12"
        :sm="field.sm ? field.sm : 12"
        :key="fieldKey"
        :style="{'display': $_displayCheck(field) ? 'initial' : 'none'}"
      >
        <WsState
          :placeholder="`請輸入${field.label}`"
          :type="field.type"
          :label="field.label"
          :fields="field.fields"
          :rules="field.rules"
          :displayLabel="field.displayLabel"
          :displayCheck="field.displayCheck"
          :originData="originData"
          :maxlength="field.maxlength"
          :autofocus="field.autofocus"
          :value="$_value(fieldKey)"
          @input="$_onInput($event,fieldKey)"
          :hasCloseChips="field.hasCloseChips"
          :uploadUrl="field.uploadUrl"
          :requiredField="field.requiredField"
          :items="field.items"
          :textKey="field.textKey"
          :modelName="field.modelName"
          :getText="field.getText"
          :disabled="disabled"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  methods: {
    $_onInput($event, fieldKey) {
      const _value = JSON.parse(JSON.stringify(this.value));
      _value[this.$store.state.locale.selectingLocale] = {..._value[this.$store.state.locale.selectingLocale], [fieldKey]: $event};
      this.$emit("input", _value);
    },
    $_valueInit() {
      const initValue = {};
      this._locales.forEach((locale) => {
        if (locale.code === this._selectingLocale) {
          initValue[locale.code] = {};
          for (let fieldKey in this.fields) {
            const field = this.fields[fieldKey];
            if (
              this.value &&
              this.value[locale.code] &&
              this.value[locale.code][fieldKey]
            ) {
              initValue[locale.code][fieldKey] =
                this.value[locale.code][fieldKey];
            } else if (field.defaultValue !== undefined) {
              initValue[locale.code][fieldKey] = field.defaultValue;
            } else {
              initValue[locale.code][fieldKey] = "";
            }
          }
        }
      });
      this.$emit("input", initValue);
    },
    $_value(fieldKey) {
      if (
        this.value[this._selectingLocale] &&
        this.value[this._selectingLocale][fieldKey]
      ) {
        return this.value[this._selectingLocale][fieldKey];
      }
      return null;
    },
    $_displayCheck(field) {
      if (field.displayCheck) {
        if (field.displayCheck(this.originData)) {
          return true;
        } else {
          return field.displayCheck(this.originData);
        }
      } else {
        return true;
      }
    }
  },
  mounted() {
    this.$_valueInit();
  },
  props: {
    fields: Object,
    value: {
      type: [Object, String],
      default: null,
    },
    originData: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    _localeItems() {
      const _localeItems = [];
      this._locales.forEach((locale) => {
        _localeItems.push({
          value: locale.code,
          text: locale.name,
        });
      });
      return _localeItems;
    },
    _locales() {
      return this.$store.state.locale.locales;
    },
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
  },
  watch: {
    _selectingLocale: {
      deep: true,
      handler() {
        this.$_valueInit();
      },
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-state-locales.scss";
</style>